import { render, staticRenderFns } from "./voximplant.vue?vue&type=template&id=76d354c8&scoped=true&"
import script from "./voximplant.vue?vue&type=script&lang=js&"
export * from "./voximplant.vue?vue&type=script&lang=js&"
import style0 from "./voximplant.vue?vue&type=style&index=0&id=76d354c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d354c8",
  null
  
)

export default component.exports